import { Button, Card, Text } from "react-native-paper";
import { StyleSheet, View } from "react-native";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCompanyDocuments } from "../../services/firestoreServices";
import { useAppSelector } from "../../redux/store";
import { JoinRequest } from "../../types/types";
import { declineRequest, updateRequest } from "../../services/employeeServices";

type Props = {
  navToPicker: (options: any) => void;
};

export const JoinRequestsList = ({ navToPicker }: Props) => {
  const company = useAppSelector((state) => state.auth.user.company);
  const config = useAppSelector((state) => state.auth.config);

  const [requests, setRequests] = useState<JoinRequest[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    getCompanyDocuments("joinRequests").then((data: JoinRequest[]) => {
      const filtered = data.filter((item) => item.status === "PENDING");
      setRequests(filtered);
    });
  }, []);

  const acceptRequest = (request: JoinRequest) => {
    if (config.defaultRole) {
      updateRequest(request, company!, config.defaultRole);
      setRequests((prev) =>
        prev.filter((request) => request.id !== request.id),
      );
    } else {
      selectRole(request);
    }
  };

  const declineRequestFn = (request: JoinRequest) => {
    declineRequest(request).then(() =>
      setRequests((prev) =>
        prev.filter((request) => request.id !== request.id),
      ),
    );
  };

  const selectRole = (request: JoinRequest) => {
    navToPicker({
      onValueChange: (role: { value: string; label: string }) => {
        updateRequest(request, company!, role.value);
        setRequests((prev) =>
          prev.filter((request) => request.id !== request.id),
        );
      },
      options: config.roles.map((role) => ({ value: role, label: role })),
      disableSearch: true,
    });
  };

  if (requests.length === 0) {
    return null;
  }
  return (
    <View style={styles.container}>
      <Text variant="headlineSmall" style={styles.header}>
        {t("Requests")}
      </Text>
      <View style={styles.requestList}>
        {requests.map((request) => (
          <Card key={request.id} contentStyle={styles.card}>
            <Text variant="titleLarge">{request.email}</Text>
            <Card.Actions>
              <View style={styles.row}>
                <Button
                  mode="outlined"
                  onPress={() => declineRequestFn(request)}
                >
                  {t("Decline")}
                </Button>
                <Button mode="contained" onPress={() => acceptRequest(request)}>
                  {t("Accept")}
                </Button>
              </View>
            </Card.Actions>
          </Card>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 10,
  },
  header: {
    marginBottom: 16,
  },
  requestList: {
    gap: 16,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
    gap: 10,
  },
  button: {
    justifyContent: "center",
  },
  card: {
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 8,
  },
});
